import styled from 'styled-components';

import { errorColor } from '~theme';

const Phone = ({ label, required, error, ...props }) => (
  <PhoneInput
    {...props}
    className="form-control"
    maxLength="100"
    autoComplete="tel-national"
  />
);

const PhoneInput = styled.input`
  width: 100%;
  height: 40px;

  border-color: ${props => (props.error ? errorColor : '')};
  font-size: 16px;

  padding: 0 10px;

  border: none;
  border: solid 1px #b3b3b3;
  border-radius: 4px;
`;

export default Phone;
